module.exports = __webpack_public_path__ + "img/completion3.4e4a12a5.svg";